(() => {
  const init = root => {
    if (!root || root.dataset.wholesaleReady === 'true') return;
    root.dataset.wholesaleReady = 'true';

    const enquirySelect = root.querySelector('[data-enquiry-select]');
    root.querySelectorAll('[data-enquiry-type]').forEach(button => {
      button.addEventListener('click', () => {
        if (enquirySelect) {
          const requested = button.dataset.enquiryType || '';
          const option = [...enquirySelect.options].find(item => item.text.trim() === requested.trim());
          if (option) enquirySelect.value = option.value;
        }
        root.querySelector('#wholesale-enquiry')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => enquirySelect?.focus(), 650);
      });
    });

    root.querySelectorAll('[data-wholesale-message]').forEach(message => {
      const count = message.parentElement?.querySelector('[data-wholesale-count]');
      const update = () => { if (count) count.textContent = String(message.value.length); };
      message.addEventListener('input', update);
      update();
    });

    root.querySelectorAll('.wholesale-faq-item > button').forEach(button => {
      button.addEventListener('click', () => {
        const answer = button.nextElementSibling;
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        if (answer) answer.hidden = open;
      });
    });
  };

  const initAll = () => document.querySelectorAll('[data-wholesale-page]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-wholesale-page]')));
})();
